import { type RunReply, type RunRequest, runBacktest } from "./backtestClient.ts"

// Where a pane's backtest runs: catalogue strategies in the backtest worker,
// user strategies ("user:<id>@<v>") and editor drafts ("draft:<key>") in the
// user-script worker. The reply is the same either way, so the tester doesn't
// care which.

export const isUserStrategyId = (strategyId: string): boolean => strategyId.startsWith("user:") || strategyId.startsWith("draft:")

export const runPaneStrategy = async (pane: number, request: RunRequest): Promise<RunReply> => {
  if (!isUserStrategyId(request.strategyId)) return runBacktest(pane, request)
  try {
    const { runUserStrategy } = await import("./userStrategyRuns.ts")
    return await runUserStrategy(pane, request)
  } catch (error) {
    return { kind: "error", message: `the strategy runner couldn't load (${error instanceof Error ? error.message : String(error)}). Reload the page.` }
  }
}
